import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[620px] md:h-[700px] overflow-hidden">
      {/* Background image */}
      <img
        src="https://readdy.ai/api/search-image?query=A%20stunning%20Korean%20webtoon%20style%20panoramic%20illustration%20of%20a%20dreamy%20fantasy%20library%20with%20floating%20books%20and%20glowing%20pages%2C%20warm%20golden%20amber%20and%20soft%20coral%20lighting%2C%20ethereal%20atmosphere%2C%20magical%20dust%20particles%2C%20cozy%20reading%20nook%2C%20Korean%20manhwa%20art%20style%2C%20cinematic%20wide%20shot%2C%20rich%20warm%20tones%2C%20storytelling%20aesthetic%2C%20clean%20composition&width=1800&height=800&seq=hero-kumanwu-main&orientation=landscape"
        alt="酷漫屋 - 下拉式免费漫画阅读平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      {/* Dark overlay for text readability */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      {/* Content */}
      <div className="relative z-10 w-full h-full flex items-center px-6 md:px-12 lg:px-20">
        <div className="flex flex-col gap-6 max-w-2xl">
          <div className="flex flex-col gap-3">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-white leading-tight tracking-tight" style={{ fontFamily: "var(--font-heading)" }}>
              发现你的<br />下一个最爱<br />漫画故事
            </h1>
            <p className="text-base md:text-lg text-white/75 leading-relaxed max-w-lg">
              海量韩漫、国漫免费看，下拉式阅读体验，高清流畅，每日更新
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 pt-2">
            <Link
              to="/category/hanman"
              className="inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full bg-foreground-950 text-background-50 text-sm font-semibold hover:bg-foreground-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              立即探索
              <i className="ri-arrow-right-line text-base"></i>
            </Link>
            <Link
              to="/category/hanman"
              className="inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full border border-white/30 text-white text-sm font-medium hover:bg-white/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              热门排行
              <i className="ri-fire-line text-base"></i>
            </Link>
          </div>

          {/* Stats */}
          <div className="flex flex-wrap gap-6 md:gap-10 pt-6">
            <div className="flex flex-col">
              <span className="text-2xl md:text-3xl font-bold text-white">12万+</span>
              <span className="text-xs md:text-sm text-white/60">漫画作品</span>
            </div>
            <div className="flex flex-col">
              <span className="text-2xl md:text-3xl font-bold text-white">5800万+</span>
              <span className="text-xs md:text-sm text-white/60">累计用户</span>
            </div>
            <div className="flex flex-col">
              <span className="text-2xl md:text-3xl font-bold text-white">300+</span>
              <span className="text-xs md:text-sm text-white/60">每日更新</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}